(function() {
  'use strict';

  const slider = document.getElementById('aiello-arq-calc-slider');
  if (!slider) return;

  const valueEl = document.getElementById('aiello-arq-calc-value');
  const clienteEl = document.getElementById('aiello-arq-calc-cliente');
  const pontosEl = document.getElementById('aiello-arq-calc-pontos');
  const cashbackEl = document.getElementById('aiello-arq-calc-cashback');

  function formatBR(num) {
    return num.toLocaleString('pt-BR');
  }

  function formatMoney(num) {
    return num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function update() {
    const valor = parseInt(slider.value, 10);
    const descontoCliente = Math.round(valor * 0.05);
    const valorPago = valor - descontoCliente;
    const pontos = valorPago;
    const cashback = pontos * 0.10;

    if (valueEl) valueEl.textContent = formatBR(valor);
    if (clienteEl) clienteEl.textContent = formatBR(descontoCliente);
    if (pontosEl) pontosEl.textContent = formatBR(pontos);
    if (cashbackEl) cashbackEl.textContent = formatMoney(cashback);

    const percent = ((valor - slider.min) / (slider.max - slider.min)) * 100;
    slider.style.background =
      'linear-gradient(to right, var(--aiello-gold) 0%, var(--aiello-gold) ' + percent + '%, var(--aiello-cream) ' + percent + '%, var(--aiello-cream) 100%)';
  }

  slider.addEventListener('input', update);
  update();
})();
